import { Button } from "antd";
import React from "react";
import { useHistory } from "react-router";

const BackButton = () => {
  const history = useHistory();
  return (
    <Button type="primary" onClick={() => history.goBack()}>
      Ортга
    </Button>
  );
};

export default BackButton;
